<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div style="text-align:center;margin-bottom:20px">
      <i class="el-icon-warning" style="font-size:24px;color:#E6A23C"></i>
      <p style="margin-top:10px">确定删除该店铺广告吗？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteStoreAds">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteMallAd } from '@/api/storeAds/storeAdsApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      deleteStoreAdsInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteStoreAdsInfo = { ...row }
    },
    async deleteStoreAds() {
      let shopId = getShopId()
      this.deleteStoreAdsInfo.shopId = shopId
      try {
        const res = await deleteMallAd(this.deleteStoreAdsInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleClose() {
      this.deleteStoreAdsInfo = {}
    }
  }
}
</script>